import { render, staticRenderFns } from "./CreatVersion.vue?vue&type=template&id=d0998ce0&scoped=true"
import script from "./CreatVersion.vue?vue&type=script&lang=js"
export * from "./CreatVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0998ce0",
  null
  
)

export default component.exports